import React from "react";
import { NavLink } from "react-router-dom";
import "./listProducts.css";

function ListProducts() {
	return (
		<div className='conteiner'>
			<div className='box__products'>
				<h1 className='box__title'>Nasze Produkty</h1>
				<nav className='product__list'>
					<NavLink className='product__list__item' to='/klasaa1'>
						<p>Pellet Klasy A1</p>
						<svg
							height='200px'
							width='200px'
							version='1.1'
							id='Layer_1'
							xmlns='http://www.w3.org/2000/svg'
							viewBox='0 0 510.347 510.347'>
							<g transform='translate(1 1)'>
								<g>
									<g>
										<path
											d='M280.653,143.24c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533c-33.28,0-59.733-15.36-59.733-34.133
				c0-5.12-3.413-8.533-8.533-8.533c-5.12,0-8.533,3.413-8.533,8.533C203.853,121.053,237.133,143.24,280.653,143.24z'
										/>
										<path
											d='M280.653,57.907c33.28,0,59.733,15.36,59.733,34.133c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				c0-29.013-33.28-51.2-76.8-51.2c-5.12,0-8.533,3.413-8.533,8.533S275.533,57.907,280.653,57.907z'
										/>
										<path
											d='M504.227,285.747l-87.04-87.04V92.04c0-47.787-59.733-85.333-136.533-85.333S144.12,44.253,144.12,92.04v213.333
				l-34.084-45.445c0.172-27.118-9.23-52.482-28.209-71.462C63.053,168.84,36.6,158.6,7.587,160.307l-8.533,0.853v7.68
				C-1.8,197,7.587,223.453,27.213,243.08c18.773,17.92,43.52,28.16,69.973,28.16l0,0l20.821,27.762l-44.715,14.905
				c-4.267,1.707-6.827,6.827-5.12,11.093c0.853,3.413,4.267,5.973,7.68,5.973c0.853,0,1.707,0,3.413-0.853l49.664-16.555
				l15.189,20.252v108.089c0,23.893,43.52,59.733,136.533,59.733c93.867,0,136.533-34.987,136.533-59.733V319.88l26.453,26.453
				c2.56,3.413,7.68,5.12,11.947,5.12c4.267,0,8.533-2.56,12.8-5.12l35.84-35.84C511.053,303.667,511.053,292.573,504.227,285.747z
				 M16.12,177.373c20.48,0.853,39.253,8.533,53.76,23.04c11.227,11.227,18.347,25.017,21.396,40.169l-35.049-35.049
				c-3.413-3.413-8.533-3.413-11.947,0s-3.413,8.533,0,11.947l35.049,35.049c-15.152-3.049-28.942-10.168-40.169-21.396
				C24.653,216.627,16.973,197.853,16.12,177.373z M280.653,23.773c64.853,0,119.467,31.573,119.467,68.267
				c0,36.693-54.613,68.267-119.467,68.267c-64.853,0-119.467-31.573-119.467-68.267C161.187,55.347,215.8,23.773,280.653,23.773z
				 M280.653,484.573c-83.627,0-119.467-30.72-119.467-42.667V133.992c4.171,4.717,9.036,9.146,14.517,13.238
				c0.382,0.288,0.767,0.574,1.155,0.858c0.109,0.079,0.22,0.157,0.329,0.236c20.461,14.865,49.084,24.95,81.922,28.038
				c0.26,0.025,0.519,0.049,0.78,0.073c0.919,0.083,1.839,0.163,2.764,0.235c0.547,0.043,1.098,0.08,1.648,0.119
				c1.004,0.071,2.009,0.138,3.02,0.196c1.028,0.059,2.058,0.114,3.093,0.16c0.528,0.023,1.059,0.041,1.589,0.061
				c0.973,0.036,1.95,0.066,2.929,0.09c0.467,0.011,0.933,0.024,1.401,0.032c1.435,0.026,2.874,0.044,4.321,0.044
				s2.886-0.018,4.321-0.044c0.468-0.009,0.934-0.021,1.401-0.032c0.979-0.024,1.956-0.054,2.929-0.09
				c0.53-0.02,1.061-0.038,1.589-0.061c1.035-0.046,2.066-0.1,3.094-0.16c1.01-0.058,2.014-0.125,3.017-0.196
				c0.55-0.039,1.102-0.077,1.65-0.12c0.925-0.072,1.845-0.152,2.763-0.235c0.261-0.024,0.521-0.048,0.781-0.073
				c32.837-3.088,61.46-13.173,81.92-28.038c0.11-0.079,0.221-0.157,0.33-0.237c0.389-0.284,0.773-0.571,1.156-0.859
				c5.481-4.092,10.345-8.521,14.516-13.237v307.915C400.12,454.707,365.987,484.573,280.653,484.573z M454.733,333.533
				l-37.547-37.547v-72.533l73.387,74.24L454.733,333.533z'
										/>
										<path
											d='M195.32,279.773c-5.12,0-8.533,3.413-8.533,8.533v153.6c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-153.6
				C203.853,283.187,200.44,279.773,195.32,279.773z'
										/>
										<path
											d='M237.987,228.573c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-51.2
				C246.52,231.987,243.107,228.573,237.987,228.573z'
										/>
										<path
											d='M280.653,194.44c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-51.2
				C289.187,197.853,285.773,194.44,280.653,194.44z'
										/>
										<path
											d='M195.32,185.907c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-51.2
				C203.853,189.32,200.44,185.907,195.32,185.907z'
										/>
										<path
											d='M365.987,279.773c-5.12,0-8.533,3.413-8.533,8.533v93.867c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				v-93.867C374.52,283.187,371.107,279.773,365.987,279.773z'
										/>
										<path
											d='M365.987,185.907c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-51.2
				C374.52,189.32,371.107,185.907,365.987,185.907z'
										/>
										<path
											d='M323.32,185.907c-5.12,0-8.533,3.413-8.533,8.533v25.6c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-25.6
				C331.853,189.32,328.44,185.907,323.32,185.907z'
										/>
										<path
											d='M280.653,407.773c-5.12,0-8.533,3.413-8.533,8.533v25.6c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-25.6
				C289.187,411.187,285.773,407.773,280.653,407.773z'
										/>
										<path
											d='M365.987,416.307c-5.12,0-8.533,3.413-8.533,8.533v17.067c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				V424.84C374.52,419.72,371.107,416.307,365.987,416.307z'
										/>
										<path
											d='M323.32,254.173c-5.12,0-8.533,3.413-8.533,8.533v25.6c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-25.6
				C331.853,257.587,328.44,254.173,323.32,254.173z'
										/>
										<path
											d='M280.653,288.307c-5.12,0-8.533,3.413-8.533,8.533v76.8c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-76.8
				C289.187,291.72,285.773,288.307,280.653,288.307z'
										/>
										<path
											d='M237.987,322.44c-5.12,0-8.533,3.413-8.533,8.533v76.8c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-76.8
				C246.52,325.853,243.107,322.44,237.987,322.44z'
										/>
										<path
											d='M323.32,322.44c-5.12,0-8.533,3.413-8.533,8.533v76.8c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-76.8
				C331.853,325.853,328.44,322.44,323.32,322.44z'
										/>
									</g>
								</g>
							</g>
						</svg>
					</NavLink>
					<NavLink className='product__list__item' to='/przemyslowy'>
						<p>Pellet Przemysłowy</p>
						<svg
							version='1.0'
							xmlns='http://www.w3.org/2000/svg'
							width='200px'
							height='200px'
							viewBox='0 0 225.000000 225.000000'
							preserveAspectRatio='xMidYMid meet'>
							<g
								transform='translate(0.000000,225.000000) scale(0.100000,-0.100000)'
								stroke='none'>
								<path
									d='M918 2239 c-15 -8 -18 -25 -18 -99 l0 -88 -67 -21 c-38 -11 -98 -36
-135 -55 l-67 -34 -59 59 c-38 38 -67 59 -82 59 -33 0 -300 -267 -300 -300 0
-15 21 -44 59 -82 l59 -59 -34 -67 c-19 -37 -44 -97 -55 -134 l-21 -68 -89 0
c-77 0 -90 -2 -99 -19 -13 -26 -13 -386 0 -412 9 -17 22 -19 99 -19 l89 0 21
-67 c11 -38 36 -98 55 -135 l34 -67 -59 -59 c-35 -35 -59 -67 -59 -80 0 -31
270 -302 300 -302 15 0 45 21 82 59 l59 59 67 -34 c37 -19 97 -44 135 -55 l67
-21 0 -89 c0 -77 2 -90 19 -99 26 -13 386 -13 412 0 17 9 19 22 19 99 l0 89
68 21 c37 11 97 36 134 55 l67 34 59 -59 c34 -34 68 -59 80 -59 28 0 302 274
302 302 0 12 -25 46 -59 80 l-59 59 34 67 c19 37 44 97 55 135 l21 67 89 0
c77 0 90 2 99 19 13 26 13 386 0 412 -9 17 -22 19 -99 19 l-89 0 -21 68 c-11
37 -36 97 -55 134 l-34 67 59 59 c38 38 59 67 59 82 0 33 -267 300 -300 300
-15 0 -44 -21 -82 -59 l-59 -59 -67 34 c-37 19 -97 44 -134 55 l-68 21 0 89
c0 77 -2 90 -19 99 -26 13 -390 13 -413 -1z m352 -164 c0 -97 -6 -90 103 -120
32 -9 102 -38 155 -65 53 -28 100 -50 105 -50 5 0 35 26 68 57 l60 57 96 -97
97 -96 -57 -60 c-31 -33 -57 -63 -57 -68 0 -5 22 -52 50 -105 27 -53 56 -123
65 -155 30 -109 23 -103 120 -103 l85 0 0 -145 0 -145 -85 0 c-97 0 -90 6
-120 -103 -9 -32 -38 -102 -65 -155 -28 -53 -50 -100 -50 -105 0 -5 26 -35 57
-68 l57 -60 -97 -96 -96 -97 -60 57 c-33 31 -63 57 -68 57 -5 0 -52 -22 -105
-50 -53 -27 -123 -56 -155 -65 -109 -30 -103 -23 -103 -120 l0 -85 -145 0
-145 0 0 85 c0 97 6 90 -103 120 -32 9 -102 38 -155 65 -53 28 -100 50 -105
50 -5 0 -35 -26 -68 -57 l-60 -57 -96 97 -97 96 57 60 c31 33 57 63 57 68 0 5
-22 52 -50 105 -27 53 -56 123 -65 155 -30 109 -23 103 -120 103 l-85 0 0 145
0 145 85 0 c97 0 90 -6 120 103 9 32 38 102 65 155 28 53 50 100 50 105 0 5
-26 35 -57 68 l-57 60 97 96 96 97 60 -57 c33 -31 63 -57 68 -57 5 0 52 22
105 50 53 27 123 56 155 65 109 30 103 23 103 120 l0 85 145 0 145 0 0 -85z'
								/>
								<path
									d='M1055 1618 c-99 -10 -213 -68 -288 -147 -106 -111 -152 -249 -136
-411 9 -91 31 -140 62 -140 45 0 53 23 32 101 -55 214 68 433 282 499 80 25
145 25 229 3 73 -20 99 -12 99 28 0 50 -134 82 -280 67z'
								/>
								<path
									d='M1418 1481 c-20 -16 -21 -22 -10 -45 13 -29 42 -34 66 -10 19 18 19
20 6 43 -14 28 -37 32 -62 12z'
								/>
								<path
									d='M1510 1330 c-8 -15 -5 -37 11 -91 65 -213 -60 -442 -278 -509 -82
-25 -154 -25 -235 0 -83 26 -96 25 -110 -6 -11 -23 -10 -29 11 -45 55 -45 241
-66 343 -39 188 50 347 231 366 416 9 91 -1 191 -27 248 -16 37 -25 46 -45 46
-15 0 -30 -8 -36 -20z'
								/>
								<path
									d='M762 838 c-30 -30 -1 -75 43 -64 22 6 26 11 23 39 -2 26 -8 33 -28
35 -14 2 -31 -3 -38 -10z'
								/>
							</g>
						</svg>
					</NavLink>
					<NavLink className='product__list__item' to='/agropellet'>
						<p className='product__text'>Agro Pellet</p>
						<svg
							version='1.0'
							xmlns='http://www.w3.org/2000/svg'
							width='200px'
							height='200px'
							viewBox='0 0 450.000000 450.000000'
							preserveAspectRatio='xMidYMid meet'>
							<g
								transform='translate(0.000000,450.000000) scale(0.100000,-0.100000)'
								stroke='none'>
								<path
									d='M2111 3485 c-22 -19 -31 -37 -35 -68 -9 -64 -86 -812 -86 -831 0 -14
-23 -16 -225 -16 l-225 0 0 113 c0 120 -5 133 -52 150 -17 6 -18 27 -18 245
l0 238 40 39 c31 31 40 46 40 74 l0 34 -64 -59 -64 -59 -1 -256 -1 -257 -25
-6 c-36 -9 -45 -42 -45 -157 l0 -99 -282 0 c-390 0 -374 11 -363 -261 l8 -179
-86 0 c-124 0 -130 -9 -125 -180 4 -127 9 -131 99 -71 66 44 153 75 239 86
164 20 368 -74 459 -211 55 -84 22 -79 518 -82 243 -1 457 1 475 6 48 12 74
56 81 140 8 86 38 186 83 275 144 288 463 469 778 442 329 -28 602 -242 706
-553 16 -49 30 -99 30 -111 0 -17 6 -21 34 -21 19 0 42 -3 51 -6 15 -6 16 -1
10 42 -27 186 -154 406 -313 540 -45 37 -90 87 -116 127 l-42 66 -18 203 c-39
448 -57 621 -66 638 -28 52 -5 50 -711 50 l-657 0 -31 -25z m538 -134 c8 -14
2 -102 -19 -308 -17 -158 -30 -298 -30 -310 0 -48 -19 -53 -195 -53 -184 0
-200 5 -191 63 3 18 17 149 32 292 14 143 30 277 35 298 l10 37 174 0 c161 0
175 -1 184 -19z m679 6 c16 -19 55 -633 42 -658 -10 -18 -24 -19 -271 -19
-169 0 -267 4 -281 11 -19 10 -20 17 -13 132 17 309 35 520 46 533 16 20 461
21 477 1z m-2080 -869 c-3 -10 -43 -14 -143 -16 -123 -2 -137 -1 -125 13 17
20 274 23 268 3z m-8 -83 c-10 -12 -39 -15 -142 -15 -115 0 -129 2 -118 15 10
12 39 15 142 15 115 0 129 -2 118 -15z m4 -70 c-5 -12 -30 -15 -135 -15 -118
0 -141 4 -122 23 3 4 64 7 134 7 110 0 128 -2 123 -15z m-4 -80 c-10 -12 -39
-15 -142 -15 -115 0 -129 2 -118 15 10 12 39 15 142 15 115 0 129 -2 118 -15z'
								/>
								<path
									d='M3109 2454 c-10 -13 -24 -15 -62 -10 -49 7 -117 -7 -117 -25 0 -14
-60 -41 -77 -35 -18 7 -93 -33 -93 -49 0 -18 -44 -55 -66 -55 -24 0 -74 -49
-74 -73 0 -24 -29 -67 -46 -67 -21 0 -67 -75 -60 -98 7 -21 -12 -72 -26 -72
-20 0 -39 -71 -32 -120 5 -36 2 -54 -10 -71 -19 -28 -21 -78 -3 -104 21 -30
27 -66 16 -87 -13 -24 6 -87 32 -108 10 -8 23 -36 28 -62 9 -53 34 -96 59
-105 22 -9 47 -43 48 -67 2 -23 57 -76 80 -76 22 0 64 -30 64 -46 0 -21 47
-46 103 -55 36 -6 57 -16 69 -31 15 -20 26 -23 90 -23 40 0 83 -6 95 -12 31
-18 98 -16 114 3 10 13 24 15 65 10 51 -6 114 8 114 25 0 14 60 41 77 35 17
-7 93 34 93 50 0 16 44 54 62 54 26 0 78 50 78 73 0 22 43 77 59 77 16 0 52
72 46 91 -7 20 10 60 31 72 20 12 34 75 27 123 -4 30 -1 49 11 65 19 28 20 65
3 99 -21 40 -27 72 -17 90 13 23 -7 91 -31 110 -11 9 -22 33 -25 55 -8 54 -34
104 -59 111 -24 8 -50 42 -51 68 -2 23 -57 76 -80 76 -22 0 -64 30 -64 46 0
21 -47 46 -103 55 -31 5 -58 16 -67 27 -24 30 -73 43 -110 29 -26 -10 -36 -9
-61 6 -39 22 -112 23 -130 1z m234 -347 c125 -57 228 -197 242 -330 14 -129
-36 -259 -135 -350 -84 -78 -147 -101 -275 -101 -137 0 -196 23 -286 113 -71
72 -90 106 -115 202 -52 203 81 428 285 486 75 21 215 11 284 -20z'
								/>
								<path
									d='M3144 1810 c-85 -35 -60 -164 31 -164 72 0 111 84 63 138 -26 29 -63
39 -94 26z'
								/>
								<path
									d='M845 1900 c-4 -7 -23 -8 -49 -5 -34 5 -45 3 -60 -14 -11 -12 -30 -21
-43 -21 -31 0 -63 -17 -63 -33 0 -7 -19 -21 -42 -32 -33 -15 -44 -27 -51 -52
-4 -18 -14 -33 -22 -33 -18 0 -39 -37 -41 -73 -1 -15 -10 -34 -20 -42 -14 -10
-18 -24 -16 -59 1 -25 -3 -48 -8 -51 -13 -8 -13 -52 0 -60 5 -3 9 -29 8 -57 0
-39 4 -54 18 -65 10 -7 19 -23 20 -36 2 -39 13 -62 36 -72 13 -6 24 -19 26
-30 5 -26 31 -55 49 -55 17 0 43 -24 43 -39 0 -12 34 -25 76 -30 6 0 21 -10
34 -21 19 -17 32 -19 67 -14 29 4 43 3 43 -5 0 -6 16 -11 35 -11 19 0 35 4 35
10 0 5 23 8 51 7 38 -1 54 2 63 16 7 9 26 19 42 21 43 6 58 14 69 39 6 12 20
23 31 25 26 4 51 29 56 57 2 11 13 24 26 30 23 10 34 33 36 72 1 13 10 29 20
36 14 11 18 26 18 65 -1 28 3 54 8 57 14 9 12 38 -5 71 -9 19 -11 32 -4 40 11
14 -4 60 -21 66 -7 2 -13 17 -14 33 -2 39 -23 75 -42 75 -8 0 -17 13 -20 30
-7 30 -23 50 -46 54 -29 6 -48 19 -48 32 0 17 -31 34 -63 34 -13 0 -32 9 -43
21 -15 17 -26 19 -60 14 -26 -3 -45 -2 -49 5 -3 5 -21 10 -40 10 -19 0 -37 -5
-40 -10z m126 -205 c104 -36 169 -130 169 -244 0 -83 -22 -133 -83 -188 -78
-71 -193 -90 -282 -46 -47 24 -104 84 -126 132 -12 28 -19 66 -19 105 0 179
171 299 341 241z'
								/>
								<path
									d='M836 1498 c-22 -31 -20 -64 4 -88 27 -27 62 -25 88 3 43 46 17 107
-46 107 -21 0 -36 -7 -46 -22z'
								/>
							</g>
						</svg>
					</NavLink>
				</nav>
			</div>
		</div>
	);
}

export default ListProducts;
